// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24LVM","top":"styles_top__16PD8","left":"styles_left__3e1sO","description":"styles_description__1Dn7s"};